
import { Vue, Component, Prop } from "vue-property-decorator";
import DownloadExport from "@/components/DownloadExport.vue";
import Loader from "@/components/Loader.vue";
import DateRangeSlider from "@/components/DateRangeSlider.vue";

@Component({ components: { DownloadExport, Loader, DateRangeSlider } })
export default class Download extends Vue {
  @Prop({ required: true })
  id!: string;

  type = "";
  dateRange = ["", ""];

  data: any = null;

  get isGrundwasser() {
    return this.data.messstellenart[0].MESSSTELLENART == "Grundwasserstände";
  }

  get defaultRules(): ((v: any) => boolean | string)[] {
    return [v => !!v || "Erforderliche Angabe"];
  }

  get dates() {
    if (!this.type || !this.data) {
      return [];
    }
    return this.data[this.type].map(e => e.ANA_DATUM).sort();
  }

  get baseWhere() {
    return ["messst_nr=" + this.id];
  }

  get where() {
    return [
      ...this.baseWhere,
      "ana_datum>=isodate:" + this.dateRange[0],
      "ana_datum<=isodate:" + this.dateRange[1]
    ];
  }
}
